import { createBrowserHistory } from 'history';
const browserHistory = createBrowserHistory();

export const goBack =()=>{
setTimeout(() => {
    browserHistory.back();
   }, 3000)
}
